import { getQueryString, updateUrlParameter } from './url';
import { extendExtraAttr } from './appAnalyzeUtils';
import { extendMeta } from './metaData';

const IDENTITY_KEY = 'identityId';
const identityId: string | undefined = getQueryString(IDENTITY_KEY) || '';

if (identityId) {
  extendMeta({
    identityId
  });

  extendExtraAttr({
    identity_id: identityId
  });
}

export function getIdentityId() {
  return identityId || '';
}

/**
 * 给url添加身份参数
 * @param url
 */
export function getIdentifiedUrl(url: string) {
  if (identityId && typeof url === 'string') {
    return updateUrlParameter(url, IDENTITY_KEY, identityId);
  } else {
    return url;
  }
}
